"use client"

import { useState } from "react"
import { FiX, FiChevronLeft, FiChevronRight } from "react-icons/fi"

export function GalleryComponent() {
  const [selectedImage, setSelectedImage] = useState(null)
  const [currentIndex, setCurrentIndex] = useState(0)

  const images = [
    {
      id: 1,
      title: "Team Collaboration",
      src: "/images/Gallery/G1.png",
    },
    {
      id: 2,
      title: "Tech Innovation",
      src: "/images/Gallery/G2.png",
    },
    {
      id: 3,
      title: "Code Development",
      src: "/images/Gallery/G3.png",
    },
    {
      id: 4,
      title: "Office Environment",
      src: "/images/Gallery/G4.png",
    },
    {
      id: 5,
      title: "Team Meeting",
      src: "/images/Gallery/G5.png",
    },
    {
      id: 6,
      title: "Workshop Session",
      src: "/images/Gallery/G6.png",
    },
    {
      id: 7,
      title: "Creative Process",
      src: "/images/Gallery/G7.png",
    },
    {
      id: 8,
      title: "Project Discussion",
      src: "/images/Gallery/G8.png",
    },
    {
      id: 9,
      title: "Coding Session",
      src: "/images/Gallery/G9.png",
    },
    {
      id: 10,
      title: "Development Lab",
      src: "/images/Gallery/G10.jpg",
    },
    {
      id: 11,
      title: "Team Building",
      src: "/images/Gallery/G11.jpg",
    },
    {
      id: 12,
      title: "Technology Stack",
      src: "/images/Gallery/G12.jpg",
    },
    {
      id: 13,
      title: "Innovation Hub",
      src: "/images/Gallery/G13.jpg",
    },
    {
      id: 14,
      title: "Brainstorming",
      src: "/images/Gallery/G14.jpg",
    },
    {
      id: 15,
      title: "Team Success",
      src: "/images/Gallery/G15.jpg",
    },
    {
      id: 16,
      title: "Digital Solutions",
      src: "/images/Gallery/G16.jpg",
    },
  ]

  const openLightbox = (index) => {
    setSelectedImage(images[index])
    setCurrentIndex(index)
  }

  const closeLightbox = () => {
    setSelectedImage(null)
  }

  const goToPrevious = () => {
    const newIndex = currentIndex === 0 ? images.length - 1 : currentIndex - 1
    setSelectedImage(images[newIndex])
    setCurrentIndex(newIndex)
  }

  const goToNext = () => {
    const newIndex = currentIndex === images.length - 1 ? 0 : currentIndex + 1
    setSelectedImage(images[newIndex])
    setCurrentIndex(newIndex)
  }

  return (
    <div className="bg-gray-900 min-h-screen text-white">
      <style jsx global>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&family=Space+Grotesk:wght@400;500;600;700&display=swap');
        
        .text-gradient-cyan {
          background: linear-gradient(to right, #a855f7, #06b6d4);
          background-clip: text;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        .animate-pulse {
          animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
        }
      `}</style>

      {/* Breadcrumb */}
      <div className="mb-12 py-1">
        <h2 className="sm:text-xl text-left bg-purple-500 px-2 py-4 font-semibold">
          <span className="border border-dashed p-2 rounded-lg tracking-wider">Home &gt; Gallery</span>
        </h2>
      </div>

      {/* Hero Section */}
      <div className="text-center px-4 mb-16">
        <h1 className="text-sm font-bold mt-12 mb-5 bg-blue-500/80 w-max mx-auto px-4 py-1 rounded-full uppercase tracking-wider animate-pulse">
          Photo Gallery
        </h1>
        <h3 className="text-3xl md:text-5xl font-bold">
          Our <span className="text-gradient-cyan">Moments</span>
        </h3>
        <p className="text-gray-300 mt-4 max-w-2xl mx-auto">
          Explore our team, workspace, and the amazing projects we've accomplished together.
        </p>
        <div className="w-24 h-1 mt-7 rounded-2xl mx-auto bg-gradient-to-r from-purple-500 to-cyan-500"></div>
      </div>

      {/* Gallery Grid */}
      <div className="px-4 sm:px-8 py-12 max-w-fit mx-auto">
        <div className="border-2 border-purple-500 border-dotted rounded-2xl p-2">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 px-4 sm:px-8 py-12 max-w-fit border-2 border-purple-500 border-dotted rounded-2xl">
            {images.map((image, index) => (
              <div
                key={image.id}
                onClick={() => openLightbox(index)}
                className="relative group overflow-hidden rounded-xl cursor-pointer"
              >
                <img
                  src={image.src}
                  alt={image.title}
                  className="w-full h-48 object-cover transform group-hover:scale-110 border-4 border-purple-500/50 transition duration-500 rounded-xl"
                  loading="lazy"
                  onError={(e) => {
                    e.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAwIiBoZWlnaHQ9IjMwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iNDAwIiBoZWlnaHQ9IjMwMCIgZmlsbD0iIzMzMyIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LWZhbWlseT0iQXJpYWwiIGZvbnQtc2l6ZT0iMTgiIGZpbGw9IiNhYWEiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGR5PSIuM2VtIj5JbWFnZSBub3QgYXZhaWxhYmxlPC90ZXh0Pjwvc3ZnPg=='
                  }}
                />
                <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition duration-300 flex items-center justify-center rounded-xl">
                  <p className="text-white text-lg md:text-base font-semibold text-center px-2">
                    {image.title}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4"
          onClick={closeLightbox}
        >
          <div
            className="relative max-w-5xl w-full max-h-[90vh] flex flex-col"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <button
              onClick={closeLightbox}
              className="absolute -top-12 right-0 text-white hover:text-gray-300 transition-colors bg-white/10 hover:bg-white/20 rounded-full p-2 z-10"
              aria-label="Close lightbox"
            >
              <FiX size={32} />
            </button>

            {/* Image */}
            <div className="relative flex-1 flex items-center justify-center overflow-hidden rounded-2xl bg-white/5 min-h-[400px]">
              <img
                src={selectedImage.src}
                alt={selectedImage.title}
                className="max-w-full max-h-[70vh] object-contain"
                onError={(e) => {
                  e.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAwIiBoZWlnaHQ9IjMwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iNDAwIiBoZWlnaHQ9IjMwMCIgZmlsbD0iIzMzMyIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LWZhbWlseT0iQXJpYWwiIGZvbnQtc2l6ZT0iMTgiIGZpbGw9IiNhYWEiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGR5PSIuM2VtIj5JbWFnZSBub3QgYXZhaWxhYmxlPC90ZXh0Pjwvc3ZnPg=='
                }}
              />
            </div>

            {/* Title */}
            <p className="text-white text-center mt-6 text-xl font-bold">
              {selectedImage.title}
            </p>

            {/* Navigation Buttons */}
            <div className="flex items-center justify-between mt-6">
              <button
                onClick={goToPrevious}
                className="text-white hover:text-gray-300 transition-colors p-3 rounded-full bg-white/10 hover:bg-white/20 border border-gray-600 hover:border-purple-400"
                aria-label="Previous image"
              >
                <FiChevronLeft size={32} />
              </button>

              <span className="text-white text-sm font-bold">
                {currentIndex + 1} / {images.length}
              </span>

              <button
                onClick={goToNext}
                className="text-white hover:text-gray-300 transition-colors p-3 rounded-full bg-white/10 hover:bg-white/20 border border-gray-600 hover:border-purple-400"
                aria-label="Next image"
              >
                <FiChevronRight size={32} />
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
